import {
  Component,
  computed,
  inject,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Router } from "@angular/router";
import { TranslocoModule } from "@jsverse/transloco";
import { Modal } from "src/app/shared/components/utils/modal/modal";
import { FavoriteStore } from "src/app/features/store/favorite-store";

@Component({
  selector: "app-favorite-tile-error-modal",
  imports: [Modal, TranslocoModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./favorite-tile-error-modal.html",
})
export class FavoriteTileErrorModal {
  private readonly router = inject(Router);
  private readonly favoriteStore = inject(FavoriteStore);

  isOpen = computed(() => this.favoriteStore.isFavoriteTilesErrorModalOpen());
  title = computed(() => this.favoriteStore.getErrorModalTitle());
  text = computed(() => this.favoriteStore.getErrorModalTextDisclaimer());
  buttonText = computed(() => this.favoriteStore.getErrorModalCtaButtonText());

  close() {
    this.favoriteStore.setFavoriteTilesErrorModalOpen(false);
  }

  closeAndRedirect() {
    this.close();
    this.router.navigate(["/user-profile"]);
  }
}
